export const SITE_TITLE = 'InScope';
